
import { PropTypes } from 'prop-types';
const PopupDialog = ({ title, date, paragraphs }) => {
    return (
        <div className="flex flex-col gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw] ">
            <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
            <span className="text-sky-950 text-opacity-70 text-sm font-normal leading-3">
                {date}
            </span>
            <div className="text-sky-950 text-opacity-70 mb-8 text-lg flex pr-2 flex-col gap-5 font-normal overflow-y-auto scroll-bar">
                {
                    paragraphs
                }
                {/* {
                    paragraphs?.map((paragraph, index) => (
                        <p key={index}>
                            {paragraph}
                        </p>
                    ))
                } */}
            </div>
        </div>
    )
}
PopupDialog.propTypes = {
    title: PropTypes.string,
    date: PropTypes.string,
    paragraphs: PropTypes.array,
}
export default PopupDialog